import React, { FC } from 'react'
import styled from 'styled-components'
import { KVMeasurement } from 'types'

import { MeasurementSegmentLengthInput } from './MeasurementSegmentLengthInput'

const SegmentItem = styled.div`
  padding: 4px 0;
  display: flex;
  align-items: center;
  gap: 8px;
`

const SegmentLabel = styled.div`
  font-size: 14px;
  color: white;
  min-width: 80px;
`

const InputContainer = styled.div`
  flex: 1;
`

export const MeasurementSegmentsList: FC<{
  selectedMeasurement: KVMeasurement
}> = ({ selectedMeasurement }) => {
  return (
    <>
      {selectedMeasurement.segments.map((segment, index) => (
        <SegmentItem key={index}>
          <SegmentLabel>Segment {index + 1}:</SegmentLabel>
          <InputContainer>
            <MeasurementSegmentLengthInput
              selectedMeasurement={selectedMeasurement}
              selectedMeasurementSegment={segment}
            />
          </InputContainer>
        </SegmentItem>
      ))}
    </>
  )
}
